import { OctNumberField } from '@oceantech/oceantech-ui';
import clsx from 'clsx';
import { useState } from 'react';
import EditableCell from '../../../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/cells/EditableCell';
import { PaymentCellEditProps } from './types';

const PaymentInsPercentCell = ({
	rowData,
	onCellEdit,
	rowIndex,
	editable,
	cellIndex,
	selectedCell,
	setSelectedCell
}: PaymentCellEditProps) => {
	const [inputValue, setInputValue] = useState(rowData?.paymentInsPercent);
	const [errorMessage, setErrorMessage] = useState('');

	const CELL_ID = `${rowData.id}${cellIndex}`;

	return (
		<EditableCell
			disabled={!editable}
			className={clsx({
				'focus-cell': CELL_ID === selectedCell,
				'min-h-28': rowData?.id,
			})}
			textValue={rowData?.paymentInsPercent || ''}
			textClassName={clsx('text-center fw-normal spaces line-height-28', {
				'text-danger': rowData?.isCancel,
			})}
			editComponent={({ setEnableEditing }: any) => {
				return (
					<OctNumberField
						className="w-100 editable-cell"
						inputClassName="w-100 text-end"
						name="paymentInsPercent"
						maxLength={3}
						allowNegative={false}
						autoFocus
						touched
						error={errorMessage}
						value={inputValue}
						onChange={(value) => {
							setInputValue(value);
							setErrorMessage(
								value > 100 ? 'Giá trị nhập không vượt quá 100%' : ''
							);
						}}
						onBlur={() => {
							setSelectedCell(CELL_ID);

							if (errorMessage) return;

							if (inputValue !== rowData?.paymentInsPercent) {
								onCellEdit(
									rowData,
									inputValue,
									rowIndex,
									'paymentInsPercent',
									rowData.paymentInsPercent
								);
							}
							setEnableEditing(false);
						}}
					/>
				);
			}}
		/>
	);
};

export default PaymentInsPercentCell;
